var map = {
	"./AUDITING.svg": "e9c4",
	"./AUDIT_FAIL.svg": "d9e3",
	"./AUDIT_OUTTIME.svg": "56c0",
	"./BE_START.svg": "2206",
	"./CANCEL.svg": "bfd7",
	"./FINISH.svg": "8f7a",
	"./MEETING.svg": "e1f2",
	"./album.svg": "6b3d",
	"./album1.svg": "5b09",
	"./arrow-r.svg": "d6cd",
	"./arrow-t.svg": "a11f",
	"./arrow.svg": "b6e4",
	"./avatar.svg": "bec7",
	"./back.svg": "c557",
	"./blue_del.svg": "7b73",
	"./blue_edit.svg": "07fa",
	"./boy.svg": "b470",
	"./chat_icon_left.svg": "e340",
	"./chat_icon_left_3.svg": "4759",
	"./chat_icon_right.svg": "c1b7",
	"./chat_icon_right_3.svg": "1904",
	"./delete.svg": "59a1",
	"./drag.svg": "9bbf",
	"./empty.svg": "c091",
	"./err.svg": "6379",
	"./expired.svg": "8cd8",
	"./girl.svg": "4600",
	"./green_del.svg": "fb8b",
	"./green_edit.svg": "b5a2",
	"./history.svg": "c023",
	"./home.svg": "6bbe",
	"./host.svg": "1f90",
	"./icon_attendance.svg": "e0d2",
	"./icon_bookMeal.svg": "9e04",
	"./icon_bookMeeting.svg": "5fe0",
	"./icon_canteen.svg": "ef2e",
	"./icon_consumption.svg": "1666",
	"./icon_elevator.svg": "27c0",
	"./icon_meeting.svg": "d472",
	"./icon_more.svg": "6a53",
	"./icon_visitor.svg": "5bee",
	"./icon_vouchers.svg": "1846",
	"./invitation_address.svg": "6ea9",
	"./invitation_head_1.svg": "e6d9",
	"./invitation_head_2.svg": "14c4",
	"./invitation_head_3.svg": "0be5",
	"./invitation_ok.svg": "7767",
	"./invitation_ok_green.svg": "59aa",
	"./invitation_ok_lightblue.svg": "522e",
	"./invitation_record_1.svg": "acc3",
	"./invitation_time.svg": "0fb7",
	"./inviteCode.svg": "82d4",
	"./light_del.svg": "dfdc",
	"./light_edit.svg": "fb81",
	"./location.svg": "1c50",
	"./locked.svg": "2179",
	"./logo.svg": "bb69",
	"./personalData.svg": "434d",
	"./picker-arrow-l.svg": "ee9d",
	"./picker-arrow-r.svg": "b075",
	"./picture.svg": "b6c6",
	"./qrCode.svg": "ad26",
	"./setting.svg": "05ff",
	"./share.svg": "5306",
	"./share_btn.svg": "d8cf",
	"./share_copy.svg": "908f",
	"./share_wechat.svg": "ec6a",
	"./sign_in.svg": "c3fc",
	"./sign_in_blue.svg": "cb83",
	"./sign_in_green.svg": "93fa",
	"./sign_in_lightblue.svg": "7951",
	"./staff.svg": "d46f",
	"./staff_avatar.svg": "cb16",
	"./suc.svg": "26ef",
	"./unBind.svg": "cdcd",
	"./upload_img.svg": "6fb4",
	"./used.svg": "19b6",
	"./user.svg": "b3b5",
	"./visitor.svg": "40d4",
	"./个人中心1.svg": "551d",
	"./刷新.svg": "e385",
	"./单选.svg": "698d",
	"./单选（选中）.svg": "386f",
	"./异常提示icon.svg": "5614",
	"./成功.svg": "aabf",
	"./拍照-1.svg": "e3b4",
	"./来访预约1.svg": "7e1e",
	"./联系我们.svg": "1009"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";